module.exports = __webpack_public_path__ + "img/public/siteImages/siteLoginImage.svg?a75627d1";